// extracted by mini-css-extract-plugin
export default {"iconButton":"bPErkEDWeJB1pbCEje9I","iconButtonContainer":"DGbos2EP8haHX5bRXy_Q","large":"bummVxC0YM6gu89Bn1Q_","small":"oDxWwP4H_xt7SaHetCOu"};